import { AppService } from "./app.service";
import { ScriptService } from "./script.service";
import { MessagingService } from "./messaging.service";
import { BetaService } from "./beta.service";
import { WebCommunityService } from "./community.service";
import { AvoService } from "./avo.service";
import { FirebaseService } from "./firebase.service";
import { ReftagService } from "./reftag.service";
import { UsbDeviceService } from "./usb-device.service";

export const CORE_PROVIDERS: any[] = [
  // Services
  AppService,
  MessagingService,
  ScriptService,
  BetaService,
  WebCommunityService,
  AvoService,
  FirebaseService,
  ReftagService,
  UsbDeviceService,
];

export * from "./app.service";
export * from "./script.service";
export * from "./messaging.service";
export * from "./beta.service";
export * from "./community.service";
export * from "./avo.service";
export * from "./firebase.service";
export * from "./error-handler.service";
export * from "./reftag.service";
export * from "./usb-device.service";
export * from "./svg.store";
export * from "./environment-translate-loader";
